var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLeaf = function SvgIconLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.254 16.332 8.039-8.039a1 1 0 1 1 1.414 1.414l-8.039 8.04c2.986 1.333 5.781.81 7.87-1.135 2.304-2.146 3.914-6.18 3.753-11.903-5.723-.161-9.757 1.45-11.903 3.754-1.944 2.088-2.467 4.883-1.134 7.869m-1.496 1.496C2.739 13.957 3.216 10.01 5.925 7.1 8.73 4.086 13.76 2.367 20.309 2.752a1 1 0 0 1 .94.94c.385 6.548-1.335 11.578-4.349 14.384-2.91 2.709-6.856 3.185-10.728 1.166l-1.715 1.715a1 1 0 0 1-1.414-1.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLeaf;